import {
  iid_GetProperty,
  iid_Invoke,
  iid_IsAvailable,
  iid_SetProperty,
} from "../../../libs/netid/_netid";

export var isInstalled = function () {
  return location.protocol === "https:" && iid_IsAvailable();
};

// Signs the specified data using the supplied issuer filter list.
// Set useAuthCert to true to create a signature using the authentication
// certificate.
export var signData = function (data, issuers, useAuthCert) {
  iid_Invoke("Reset");
  iid_SetProperty("Authentication", useAuthCert);
  iid_SetProperty("Base64", "true");
  iid_SetProperty("UrlEncode", "false");
  //iid_SetProperty("IncludeCaCert", "true");
  //iid_SetProperty("IncludeRootCaCert", "true");
  iid_SetProperty("DataToBeSigned", data);
  iid_SetProperty("Issuers", issuers);

  var rc = iid_Invoke("Sign");

  if (rc === 0) {
    return iid_GetProperty("Signature");
  } else {
    var err = new Error();
    err.number = rc;
    err.name = "Net iD Error";
    err.description = "Failed to create signature. Error code: " + rc;

    throw err;
  }
};
